<template>
    <div>
        <BAlert
            v-if="error"
            variant="danger"
            show
        >
            <div class="alert-body">
                {{ $t('Page(ReceivedRequest):Component(SimilarReplyRequestSelection):load-error') }}
                <BButton
                    class="ml-1"
                    size="sm"
                    variant="outline-danger"
                    @click="$emit('retry')"
                >
                    {{ $t('Page(ReceivedRequest):Component(SimilarReplyRequestSelection):retry') }}
                </BButton>
            </div>
        </BAlert>

        <HamletTable
            v-else
            ref="table"
            :columns="columns"
            :fetch="fetchCandidates"
            :default-per-page="10"
            :page-options="[10, 15, 30]"
        >
            <template #header-label>
                {{ $t('Page(ReceivedRequest):Component(SimilarReplyRequestSelection):grid-label') }}
            </template>

            <template #header-controls>
                <span class="mr-1 text-muted">
                    {{ $t('Page(ReceivedRequest):Component(SimilarReplyRequestSelection):selected-count', { count: selectedRequestIds.length }) }}
                </span>
            </template>

            <template #header-cell-selected>
                <BFormCheckbox
                    :checked="areAllRequestsSelected"
                    :indeterminate="isSelectionPartial"
                    @change="toggleAll"
                />
            </template>

            <template #cell-selected="{ item }">
                <BFormCheckbox
                    :checked="isSelected(item.requestId)"
                    @change="isSelected(item.requestId) ? deselect(item.requestId) : select(item.requestId)"
                    @click.native.stop
                />
            </template>

            <template #cell-receivedAt="{ item }">
                {{ renderDateTime(item.receivedAt) }}
            </template>

            <template #cell-productName="{ item }">
                {{ item.product.name }}
            </template>

            <template #cell-productIdentifier="{ item }">
                {{ item.product.identifier }}
            </template>
        </HamletTable>

    </div>
</template>

<script>
import { BAlert, BButton, BFormCheckbox } from 'bootstrap-vue'
import HamletTable from '@core/components/common/HamletTable.vue'
import dateRenderer from '@core/mixins/date-renderer'

export default {
    name: 'SimilarReplyRequestSelection',
    components: {
        BAlert,
        BButton,
        BFormCheckbox,
        HamletTable,
    },
    mixins: [dateRenderer],
    props: {
        requests: {
            type: Array,
            default: () => [],
        },
        selectedRequestIds: {
            type: Array,
            default: () => [],
        },
        error: {
            type: [Error, String],
            default: null,
        },
    },
    data() {
        return {
            columns: [
                { key: 'selected', label: '' },
                {
                    key: 'receivedAt',
                    label: this.$t('Page(ReceivedRequests):Component(Grid):field-sent-at'),
                },
                {
                    key: 'productName',
                    label: this.$t('Page(ReceivedRequests):Component(Grid):field-product-name'),
                },
                {
                    key: 'productIdentifier',
                    label: this.$t('Page(ReceivedRequests):Component(Grid):field-product-id'),
                },
            ],
        }
    },
    computed: {
        areAllRequestsSelected() {
            return this.requests.length > 0 && this.selectedRequestIds.length === this.requests.length
        },
        isSelectionPartial() {
            return this.selectedRequestIds.length > 0 && !this.areAllRequestsSelected
        },
    },
    watch: {
        requests() {
            if (this.$refs.table) {
                this.$refs.table.refresh()
            }
        },
    },
    methods: {
        fetchCandidates(config, callback) {
            callback(this.requests.length, this.requests)
        },
        isSelected(requestId) {
            return this.selectedRequestIds.includes(requestId)
        },
        select(requestId) {
            this.$emit('update:selected-request-ids', [...this.selectedRequestIds, requestId])
        },
        deselect(requestId) {
            this.$emit('update:selected-request-ids', this.selectedRequestIds.filter(id => id !== requestId))
        },
        selectAll() {
            this.$emit('update:selected-request-ids', this.requests.map(candidate => candidate.requestId))
        },
        clearSelection() {
            this.$emit('update:selected-request-ids', [])
        },
        toggleAll() {
            if (this.areAllRequestsSelected) {
                this.clearSelection()
                return
            }

            this.selectAll()
        },
    },
}
</script>
